import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet"
import isMobile from 'is-mobile';

import PDPVideo from '../components/PDPVideo';
import track from 'we-sdk/utils/track';
import getLogger from 'we-sdk/utils/getLogger';
import LoadingCover from '../components/LoadingCover';
import { triggerInteractionsReport, removeEkoLogo } from '../lib/utils';

import '../styles/scss/templates/DefaultTemplate.scss'

const log = getLogger('DefaultTemplate');

/**
 * Video page template.
 * @export
 * @param {object} props
 * @param {object} props.pageContext - the page context that is passed from the gatsby create page API in gatstby-node.js (see more https://www.gatsbyjs.org/docs/creating-and-modifying-pages/)
 * @returns
 */
export default function DefaultTemplate({ pageContext, location }) {
    const { ekoId, productName, embedAPI } = pageContext;
    const [ekoPlayerRef, setEkoPlayerRef] = useState(null);

    useEffect(() => {
        log.debug(`Loaded with eko ID ${ekoId}`);
        // IMPORTANT - THIS IS AN EXAMPLE TRACK CALL.
        // ACTUAL ANALYTICS SPEC/REQUIREMENTS WILL BE PROVIDED LATER
        track('root.pageload', {
            projectId: ekoId
        });
    }, [ekoId]);

    useEffect(() => {
        if (!ekoPlayerRef) {
            return;
        }
        if (isMobile()) {
            setTimeout(() => {
                removeEkoLogo(ekoPlayerRef);
            }, 5000);
        }
    }, [ekoPlayerRef]);

    return (
        <>
            <Helmet>
                <title>{productName}</title>
            </Helmet>
            <div className="eko-video-container">
                <PDPVideo
                    id={ekoId}
                    embedAPI={embedAPI}
                    params={{ clearcheckpoints: true, cover: false }}
                    events={{

                        // Listen to the 'interactions' event in order to forward any interactions to parent frame as well
                        'interactions.report': (btnId, data) => {
                            // notify the parent frame that an interaction occurred
                            triggerInteractionsReport(btnId, data);
                        },

                        'addtocart': (walmartId) => {
                            track('addtocart', { walmartId });
                        }
                    }}
                    onPlayerInit={setEkoPlayerRef}
                    loadingCover={LoadingCover}
                    location={location}
                />
            </div>
        </>
    );
};
